import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'react-tooltip/dist/react-tooltip.css'
import App from './App';
import reportWebVitals from './reportWebVitals';
import { UserProvider } from './contexts/UserContext';
import { ModalProvider } from './contexts/ModalContext';
import { HelmetProvider } from 'react-helmet-async';
import ErrorBoundary from './components/shared/ErrorBoundary';
import { installHelpAnchorValidation } from './features/help/services/validateHelpAnchors';
import { assertValidOrientationTour } from './features/help/services/validateOrientationTour';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ErrorBoundary>
        <UserProvider>
          <ModalProvider>
            <App />
          </ModalProvider>
        </UserProvider>
      </ErrorBoundary>
    </HelmetProvider>
  </React.StrictMode>
);

if (process.env.NODE_ENV === 'development') {
  assertValidOrientationTour();
  const stopHelpAnchorValidation = installHelpAnchorValidation();
  if (module.hot) {
    module.hot.dispose(stopHelpAnchorValidation);
  }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
